module.exports = __webpack_public_path__ + "05eab98a12590bdf3b5270376a145d33.svg";